<template>
    <div class="form-body">
        <form class="form" @submit.prevent="enviar">
            <div class="title">{{ title }}</div>
            <div v-for="(item, index) in data" :key="item.label" class="item-form" :class="'form-' + item.name.replace(/_/g, '-')">

                <label for="fname" :style="{'color': options.inputs.color}">
                    {{ item.label }}
                </label>

                <input 
                    v-if="item.type != 'textarea' && item.type != 'select'" 
                    :id="item.name +'-'+ index" 
                    v-model="item.value" 
                    :class="item.name.replace(/_/g, '-')" 
                    :type="item.type" 
                    :placeholder="item.placeholder"
                />

                <textarea 
                    v-if="item.type == 'textarea'" 
                    :id="item.name +'-'+ index" v-model="item.value" 
                    :class="item.name.replace(/_/g, '-')" 
                    cols="20" 
                    rows="4" 
                    :placeholder="item.placeholder"
                />

                <select v-if="item.type == 'select'" :id="item.name +'-'+ index" v-model="item.value" :class="item.name.replace(/_/g, '-')" place>
                    <option :value="null">Selecione</option>
                    <option v-for="info in item.options" :key="info.id" :value="info.id">{{info[item.itemLabel]}}</option>
                </select>
                
            </div>
            <button type="submit" :style="{'background': options.button.background }">{{options.button.label}}</button>
        </form>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Object,
            default: () => {}
        },
        title: {
            type: String,
            default: ''
        },
        options: {
            type: Object,
            default: () => {}
        }
    },
    mounted() {
        if (this.options.linkCss) {
            const link = document.createElement('link')
            link.href = this.options.linkCss
            link.rel = 'stylesheet'
            document.head.appendChild(link)
        }
    }, 
    methods: {
        enviar () {
            this.$emit('input')
        }
    }
}
</script>

<style>

</style>